import React, { useState } from 'react';
import { Breadcrumb, Pagination, Row, Col } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import MasterSidebar from '@rd-web-markets/shared/dist/util/MasterSidebar';
import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { buildQueryString, parseQueryString } from '@rd-web-markets/shared/dist/services/service';
import characterReplacementsService from '@rd-web-markets/shared/src/lib/services/character_replacements.service';
import AllowedCharactersForm from '@components/admin/allowed_characters/AllowedCharactersForm';
import AllowedCharactersTable from '@components/admin/allowed_characters/AllowedCharactersTable';

export default function AllowedCharactersPage() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const {
    characterReplacements,
    fetchCharacterReplacements,
    totalPages,
    createCharacterReplacement,
    updateCharacterReplacement,
    deleteCharacterReplacement
  } = characterReplacementsService.useCrud(setLoading);

  const handleFilter = (headers, queryString) => {
    const currentParams = parseQueryString(location.search);
    const newParams = { ...currentParams, page: 1 };

    if (queryString) {
      newParams.query = queryString;
    } else {
      delete newParams.query;
    }

    history.push({ search: `?${buildQueryString(newParams)}` });
  };

  const handlePage = (pageNumber) => {
    const currentParams = parseQueryString(location.search);
    history.push({ search: `?${buildQueryString({ ...currentParams, page: pageNumber })}` });
  };

  const handleCreate = async (formData) => {
    await createCharacterReplacement(formData);
    setShowForm(false);
  };

  const currentPage = parseInt(parseQueryString(location.search).page || 1);

  const paginationItems = [];
  for (let number = 1; number <= totalPages; number++) {
    paginationItems.push(
      <Pagination.Item
        key={number}
        active={number === currentPage}
        onClick={() => handlePage(number)}
      >
        {number}
      </Pagination.Item>
    );
  }

  return (
    <>
      <BreadcrumbsPortal>
        <Breadcrumb>
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Allowed Characters</Breadcrumb.Item>
        </Breadcrumb>
      </BreadcrumbsPortal>

      <Row className='justify-content-center mx-0 mt-4'>
        <Col md={10}>
          <div className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4>{t('character_replacements')}</h4>
              <AddButton
                size="sm"
                variant="info"
                disabled={loading}
                onClick={() => setShowForm(prev => !prev)}
                text={showForm ? t('hide_form') : t('add_character_replacement')}
              />
            </div>

            {showForm && (
              <AllowedCharactersForm
                loading={loading}
                onSubmit={handleCreate}
              />
            )}

            <AllowedCharactersTable
              characterReplacements={characterReplacements}
              onUpdate={updateCharacterReplacement}
              onDelete={deleteCharacterReplacement}
              onFilter={handleFilter}
              userCanEdit={true}
              loading={loading}
            />

            {totalPages > 1 && (
              <Pagination className="justify-content-end mt-3">
                {paginationItems}
              </Pagination>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
}
